<template>
  <div>
    <!-- 添加任务 -->
    <jd-dialog
      :title="`${isTaskEdit ? '修改任务' : '添加任务'}`"
      :visible.sync="taskDialog"
      :close-on-click-modal="false"
      :width="taskForm.type == 17 ? '800px' : '700px'"
      @close="taskClose"
      v-if="taskDialog"
    >
      <el-form
        :model="taskForm"
        style="position: relative"
        class="new-input-box"
        label-width="auto"
      >
        <div
          v-if="taskIsLook"
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
          "
        ></div>
        <el-form-item label="任务类型:" required>
          <el-select
            v-model="taskForm.type"
            style="width: 350px"
            @change="taskTypeChange"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <jd-tip class="task-tip" v-if="taskForm.type == 1">
            <div>
              任务说明：用户每日都可进入活动页签到，获得{{ taskTypeText }}机会。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 2">
            <div>
              任务说明：用户每日都可进入活动页浏览店铺，获得{{
                taskTypeText
              }}机会。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 13">
            <div>任务说明：</div>
            <div>1.用户浏览商品可以获得{{ taskTypeText }}机会；</div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 4">
            <div>任务说明：</div>
            <div>1.用户成功加购商品可以获得{{ taskTypeText }}机会；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 9">
            <div>任务说明：</div>
            <div>1.用户成功分享商品可以获得{{ taskTypeText }}机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 10">
            <div>任务说明：</div>
            <div>1.用户成功分享店铺可以获得{{ taskTypeText }}机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 11">
            <div>任务说明：</div>
            <div>1.用户成功分享活动可以获得{{ taskTypeText }}机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 8">
            <div>任务说明：</div>
            <div>1.用户成功邀请好友可以获得{{ taskTypeText }}机会；</div>
            <div>
              2.被邀请人只有点击助力链接才算一次有效助力，且活动期间每人只有1次助力机会；
            </div>
            <div>3.用户在活动期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>（1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com</div>
            <div>（2） 只能以http://,https://开头</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 12">
            <div>任务说明：</div>
            <div>1.用户成功预约商品可以获得{{ taskTypeText }}机会；</div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 16">
            <div>
              任务说明：用户消耗一定积分可兑换{{ taskTypeText }}机会次数。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 17">
            <div>
              <div>任务说明：</div>
              <div>
                1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；
              </div>
              <div>2、指定购买商品：订单包含任意指定商品均会被统计；</div>
              <div>
                3、选择订单状态为“已完成”，则仅限交易完成的订单可获得{{
                  taskTypeText
                }}机会，如：活动已结束，交易未完成，则不赠送次数；
              </div>
              <div>
                4、如买家通过消费任务获得次数后进行退款的情况，已赠送的次数不会撤回；
              </div>
              <div style="color: #fe4d45">
                5、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。
              </div>
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 18">
            <div>任务说明：用户邀请好友成功入会，可获取中奖机会；</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 7">
            <div>
              任务说明：用户可参与入会任务，增加{{ taskTypeText }}机会。
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 23">
            <div>任务说明：此任务可以放搜索关键词，用户进入活动点击去搜索自动带【关键词】跳转至APP查询页查询；</div>
          </jd-tip>
        </div>
        <el-form-item label="任务有效期:" required>
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio v-model="taskForm.taskTime" :label="1"
                >长期有效</el-radio
              >
              <el-radio v-model="taskForm.taskTime" :label="2"
                >指定日期</el-radio
              >
            </div>
            <div class="my_select_time" v-if="taskForm.taskTime == 2">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.startTime"
                type="date"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.endTime"
                type="date"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time2"
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!isStart"
                @click="clearTaskTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="邀请人数上限:"
          required
          v-if="taskForm.type == 8"
        >
          <span>
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
          </span>
          人
        </el-form-item>
        <el-form-item
          label="跳转链接:"
          required
          v-if="taskForm.type == 5"
        >
          <el-input v-model="taskForm.jumpUrl"></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <template v-if="taskForm.type == 17">
          <el-form-item label="奖励规则:" required>
            <el-select
              v-model="taskForm.giveType"
              style="width: 200px"
              @change="giveTypeChange"
            >
              <el-option
                v-for="item in rewardRulesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip
              class="item"
              effect="light"
              placement="right"
              style="margin-left: 8px"
            >
              <div slot="content">
                1、按固定次数赠送{{
                  taskTypeText
                }}机会：例如设置【满10元及以上赠送1次机会】，若用户下单100元，则也只赠送1次机会；
                <br />
                2、按倍数赠送{{
                  taskTypeText
                }}机会：例如设置【每满100元及以上赠送1次机会】，若按单笔，则用户第一次下单90元，则未达到赠送条件，第二次下单110元，则赠送1次机会；
                <br />
                若按累计，则用户第一次下单90元，未达到赠送条件；第二次下单110元，两笔订单合起来为200元，则赠送2次{{
                  taskTypeText
                }}机会
                <br />
                3、按阶梯赠送{{
                  taskTypeText
                }}机会：例如设置多阶梯【满10元及以上赠送1次机会，满30元及以上赠送3次机会】，若按单笔，用户第一次下单10元，则赠送1次机会，第二次下单20元，满足“满10元未达到30元”，则赠送1次
                <br />
                若按累计，用户下单10元，则本次赠送1次机会，该用户再次下单20元，此时满足第二个阶梯30元，但是由于已经赠送了1次机会，所以再次赠送2次机会。达到满30元赠送3次机会的设置。
                <br />
              </div>
              <div
                style="
                  display: inline-flex;
                  cursor: pointer;
                  align-items: center;
                "
              >
                奖励规则说明<i
                  class="el-icon-question"
                  style="color: #ccc; margin-left: 2px"
                ></i>
              </div>
            </el-tooltip>
            <div class="rule_box">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :isCreated="isCreated"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间:" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    :picker-options="taskstartpickerOptionsValue"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 148px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    :picker-options="taskpickerOptionsValueEnd"
                    type="datetime"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="23:59:59"
                    style="width: 152px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    v-if="!isStart"
                    @click="clearOrderTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="最长时间跨度不超过90天"
                  placement="bottom"
                  style="margin-left: 8px"
                >
                  <div
                    style="width: 35px; display: inline-flex; cursor: pointer"
                  >
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </div>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="商品要求:"
                required
                class="skuType-label"
              >
                <!-- <el-radio v-model="taskForm.skuType" :label="0"
                  >全部商品</el-radio
                >
                <el-radio v-model="taskForm.skuType" :label="1"
                  >指定商品</el-radio
                >
                <div style="display: inline-block">
                  <jd-button
                    type="blue"
                    @click="showGoods(100)"
                    :disabled="taskForm.skuType != 1"
                    >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
                  >
                </div> -->
                <productReqCom
                  :filterType.sync="taskForm.skuType"
                  :venderIds.sync="taskForm.venderIds"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                  :multiShopGoods.sync="multiShopGoods"
                  :isShowExclude="false"
                  :limitNum="goodsLimit"
                  addGoodText="选择商品"
                />
              </el-form-item>
              <el-form-item
                label="订单金额:"
                v-if="taskForm.giveType == 0"
                required
              >
                大于等于<el-input
                  style="width: 120px; margin: 0 8px"
                  v-model="taskForm.amtLimit"
                  @input="validateInput"
                />元
              </el-form-item>
              <el-form-item
                label="商品件数:"
                v-if="taskForm.giveType == 0"
              >
                大于等于<el-input
                  style="width: 120px; margin: 0 8px"
                  v-model="taskForm.itemTotalLimit"
                  @input="validateInputNew"
                />件
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <el-form-item label="订单状态:" required>
                <el-radio v-model="taskForm.orderType" :label="0"
                  >已付款</el-radio
                >
                <el-radio v-model="taskForm.orderType" :label="1"
                  >已完成</el-radio
                >
              </el-form-item>
              <el-form-item label="统计方式:" required>
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="1"
                  @input="taskForm.condition2 = ''"
                  >累计订单</el-radio
                >
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="0"
                  @input="taskForm.condition2 = ''"
                  >单笔订单</el-radio
                >
              </el-form-item>
              <el-form-item
                label="统计类型:"
                v-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                required
              >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="1"
                  >按订单金额</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="2"
                  >按商品件数</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-if="taskForm.orderCountType == 1"
                  v-model="taskForm.countType"
                  :label="3"
                  >按订单笔数</el-radio
                >
              </el-form-item>
              <el-form-item label="任务条件:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  每1个订单赠送1次{{ taskTypeText }}机会
                </span>
                <span
                  v-else-if="
                    taskForm.orderCountType == 1 && taskForm.giveType == 0
                  "
                >
                  完成任务赠送1次{{ taskTypeText }}机会
                </span>
                <span v-else-if="taskForm.giveType == 1">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      placeholder="请输入次数"
                      style="width: 95px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    次{{ taskTypeText }}机会
                  </div>
                </span>
                <span v-else-if="taskForm.giveType == 2">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      @change="
                        (e) => {
                          item.giveNum = NumChange(e, 'giveNum', index);
                        }
                      "
                      placeholder="请输入次数"
                      style="width: 95px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    次{{ taskTypeText }}机会
                    <span
                      v-if="index >= 2"
                      @click="delTaskLevel(index)"
                      style="cursor: pointer"
                      ><i class="el-icon-error"></i
                    ></span>
                  </div>
                  <jd-button
                    :disabled="taskLevelList.length >= 5"
                    style="margin-right: 8px"
                    @click="addTaskLevel"
                    >添加阶梯({{ taskLevelList.length }}/5)</jd-button
                  >
                </span>
              </el-form-item>
              <el-form-item label="任务次数:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  活动期间最多完成
                  <el-input
                    v-model.number="taskForm.condition2"
                    placeholder="请输入"
                    style="width: 70px"
                    @input="
                      taskForm.condition2 = getNumberData(1, $event, 0, 1, 999)
                    "
                  ></el-input>
                  次
                </span>
                <span
                  v-else-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                >
                  <el-radio v-model="taskForm.taskDoType" :label="0"
                    >不限制次数</el-radio
                  >
                  <el-radio v-model="taskForm.taskDoType" :label="1"
                    >限制次数</el-radio
                  >
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="'限制该任务可活动' + taskTypeText + '次数上限'"
                    placement="bottom"
                    style="margin-left: 8px"
                  >
                    <div
                      style="width: 35px; display: inline-flex; cursor: pointer"
                    >
                      <i class="el-icon-question" style="color: #ccc"></i>
                    </div>
                  </el-tooltip>
                  <div v-if="taskForm.taskDoType == 1">
                    活动期间最多获得<el-input
                      v-model.number="taskForm.condition2"
                      placeholder="请输入"
                      style="width: 70px"
                      @input="
                        taskForm.condition = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input
                    >次{{ taskTypeText }}机会
                  </div>
                </span>
                <span v-else>{{ taskForm.count }}</span>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="搜索关键词:" v-if="taskForm.type == 23" required>
          <el-input 
            style="width: 320px;" 
            v-model="taskForm.searchKeyword" 
            placeholder="请输入搜索关键词，例【橙汁】"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务条件:"
          v-if="taskForm.type != 17"
          required
        >
          <span v-if="taskForm.type == 13">
            成功浏览
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 4">
            成功加购
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 9">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次商品，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 10">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次店铺，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 11">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次活动，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 12">
            每成功预约
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次{{ taskTypeText }}机会
          </span>
          <span v-else-if="taskForm.type == 16">
            每
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            积分可兑换1次机会
          </span>
          <span v-else-if="taskForm.type == 18">
            每成功邀请
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            个好友入会，赠送1次{{ taskTypeText }}机会
          </span>
          <div v-else-if="taskForm.type == 5" class="flexc-cen-x">
            <span>每成功浏览当前链接</span>
            <el-input
              class="ml8"
              style="width: 100px"
              v-model="taskForm.viewTime"
              @input="taskForm.viewTime = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8 mr8">秒，赠送</span>
            <el-input
              style="width: 100px"
              v-model="taskForm.giveLimit"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8">次补卡机会</span>
          </div>
          <span v-else>{{ taskForm.condition }}</span>
        </el-form-item>
        <el-form-item
          label="浏览商品:"
          required
          v-if="taskForm.type == 13"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="加购商品:"
          required
          v-if="taskForm.type == 4"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="分享商品:"
          required
          v-if="taskForm.type == 9"
        >
          <jd-button type="blue" @click="showGoods(1)"
            >选择商品（{{ taskForm.skuIds.length }}/1）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="预约商品:"
          required
          v-if="taskForm.type == 12"
        >
          <div class="book-good-wrap">
            <jd-button type="blue" @click="showGoods(100)"
              >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
            >
            <span class="tip-red" style="margin-left: 10px"
              >注意：请添加预约商品，非预约商品无法完成任务</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="任务次数:"
          v-if="taskForm.type != 17"
          required
        >
          <span v-if="taskForm.type == 12">
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 8">
            {{
              `活动期间内最多完成${
                taskForm.inviteLimit ? taskForm.inviteLimit : 0
              }次`
            }}
          </span>
          <span v-else-if="taskForm.type == 16">
            <el-select v-model="taskForm.activityType" placeholder="请选择">
              <el-option label="活动期间" :value="2"></el-option>
              <el-option label="每日" :value="1"></el-option>
            </el-select>
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 18">
            活动期间最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else>{{ taskForm.count }}</span>
        </el-form-item>
        <el-form-item
          :label="`${taskTypeText}机会:`"
          v-if="taskForm.type == 7"
          required
        >
          <div>
            加入会员可获取<el-input
              v-model.number="taskForm.giveLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1, 999)"
            ></el-input
            >次{{ taskTypeText }}机会
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button style="margin-right: 8px" @click="taskClose">取消</jd-button>
        <jd-button v-if="!taskIsLook" type="blue" @click="sureTask"
          >确定</jd-button
        >
      </div>
    </jd-dialog>
    <!-- 任务列表 -->
    <jd-table
      v-if="taskDataList.length > 0"
      :tableData="taskDataList"
      style="width: 100%"
    >
      <el-table-column label="任务" width="80px">
        <template slot-scope="scope">
          <span>任务{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务类型">
        <template slot-scope="scope">
          <span>{{ getTaskType(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务条件" prop="condition">
        <template slot-scope="scope">
          <span style="white-space: pre">{{ getCondition(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务次数" prop="count">
        <template slot-scope="scope">
          <span>{{ getCount(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <jd-button
            :disabled="isStart"
            type="blueText"
            style="margin-right: 8px"
            @click="editTask(scope.row, false)"
            >修改</jd-button
          >
          <jd-button
            type="blueText"
            style="margin-right: 8px"
            @click="editTask(scope.row, true)"
            >查看</jd-button
          >
          <jd-button
            :disabled="isStart"
            type="blueText"
            style="margin-right: 8px"
            @click="deleteTask(scope.row)"
            >删除</jd-button
          >
          <jd-button
            :disabled="isStart"
            type="blueText"
            style="margin-right: 8px"
            @click="upTask(scope.$index)"
            v-if="scope.$index != 0"
            >上移</jd-button
          >
          <jd-button
            :disabled="isStart"
            type="blueText"
            @click="downTask(scope.$index)"
            v-if="scope.$index != taskDataList.length - 1"
            >下移</jd-button
          >
        </template>
      </el-table-column>
    </jd-table>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="goodsLimit"
      :isShow="goodsState"
      :moduleType="true"
      :selectGoods="selectGoodsSkuList"
      @close="selectGoodsChange"
    ></select-goods>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import orderShopCom from "./multipleStoreSetting/orderShopCom.vue";
import productReqCom from "./multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isStart: {
      type: Boolean,
      default: false,
    },
    activityStartTime: {
      type: String,
      default: "",
    },
    activityEndTime: {
      type: String,
      default: "",
    },
    taskList: {
      type: Array,
      default: () => [],
    },
    taskTypeText: {
      type: String,
      default: "抽奖",
    },
  },
  components: {
    SelectGoods,
    orderShopCom,
    productReqCom
  },
  data() {
    return {
      multiShopGoods: [],
      isPremissionShow: true,
      isTaskEdit: false,
      taskTypeOptions: [
        {
          label: "每日签到",
          value: 1,
          taskCondition: `成功签到，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "浏览店铺",
          value: 2,
          taskCondition: `成功浏览店铺，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "浏览商品",
          value: 13,
          taskCondition: `成功浏览XX件商品，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "加购商品",
          value: 4,
          taskCondition: `成功加购XX件商品，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享商品",
          value: 9,
          taskCondition: `成功分享XX件商品，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享店铺",
          value: 10,
          taskCondition: `成功分享XX次店铺，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享活动",
          value: 11,
          taskCondition: `成功分享XX次活动，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "好友助力",
          value: 8,
          taskCondition: `每邀请1位好友，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间最多最多完成XX次",
        },
        {
          label: "浏览会场",
          value: 5,
          taskCondition: `成功浏览会场，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "预约商品",
          value: 12,
          taskCondition: `每成功预约XX件商品，赠送1次${this.taskTypeText}机会，最多完成YY次`,
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "积分兑换",
          value: 16,
          taskCondition: `每xx积分可兑换1次${this.taskTypeText}机会`,
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "购买商品",
          value: 17,
          taskCondition: `完成任务赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "邀请好友入会",
          value: 18,
          taskCondition: `成功邀请XX个好友入会，赠送1次${this.taskTypeText}机会`,
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "搜索关键词",
          value: 23,
          taskCondition: "成功查询关键词，赠送1次补卡机会",
          taskCount: "活动期间每日最多完成一次",
        },
      ],
      taskForm: {
        // 1.29迭代参数
        giveType: 0,
        countType: 1,
        taskDoType: 0,

        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        inviteLimit: null,
        jumpUrl: null,
        selectGoodsSkuList: [],
        venderIds: [],
        sellerSkuList: [],
      },
      taskDataList: [],
      taskIsLook: false,
      taskDialog: false,
      selectGoodsSkuList: [],
      conditionValue: [13, 4, 9, 10, 11, 12, 16, 17, 18],
      goodsTypeList: [13, 4, 9, 12],
      goodsLimitList: [13, 4, 12],
      taskLevelList: [],
      goodsLimit: 100,
      goodsState: false,
      rewardRulesOptions: [
        {
          value: 0,
          label: `按固定次数赠送${this.taskTypeText}机会`,
        },
        {
          value: 1,
          label: `按倍数赠送${this.taskTypeText}机会`,
        },
        {
          value: 2,
          label: `按阶梯赠送${this.taskTypeText}机会`,
        },
      ],
    };
  },
  watch: {
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
    value(newVal) {
      this.taskDialog = newVal;
      if (newVal) {
        this.addTask();
      }
    },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.orderPaymentType = 1
      } 
    },
  },
  computed: {
    // 获取任务类型
    getTaskType() {
      return (type) => {
        const obj = this.taskTypeOptions.find((item) => item.value == type);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const { type, condition, condition2, orderCountType } = item;
        let str = condition;
        if (type == 13) {
          str = `成功浏览${condition}件商品，赠送1次${this.taskTypeText}机会`;
        } else if (type == 4) {
          str = `成功加购${condition}件商品，赠送1次${this.taskTypeText}机会`;
        } else if (type == 9) {
          str = `成功分享${condition}次商品，赠送1次${this.taskTypeText}机会`;
        } else if (type == 10) {
          str = `成功分享${condition}次店铺，赠送1次${this.taskTypeText}机会`;
        } else if (type == 11) {
          str = `成功分享${condition}次活动，赠送1次${this.taskTypeText}机会`;
        } else if (type == 12) {
          str = `每成功预约${condition}件商品，赠送1次${this.taskTypeText}机会`;
        } else if (type == 16) {
          str = `每${condition}积分可兑换1次机会`;
        } else if (type == 17) {
          if (item.giveType == 0) {
            str =
              orderCountType == 0
                ? `每1个订单赠送1次${this.taskTypeText}机会`
                : `完成任务赠送1次${this.taskTypeText}机会`;
          } else if (item.giveType == 1) {
            this.taskLevelList.forEach((it) => {
              str = `购买商品，每满${
                item.countType == 1
                  ? it.limit + "元"
                  : item.countType == 2
                  ? it.limit + "件"
                  : item.countType == 3
                  ? it.limit + "笔"
                  : ""
              }可赠送${it.giveNum}次${this.taskTypeText}机会`;
            });
          } else if (item.giveType == 2) {
            str = `购买商品：`;
            this.taskLevelList.forEach((it) => {
              str =
                str +
                `\n满${
                  item.countType == 1
                    ? it.limit + "元"
                    : item.countType == 2
                    ? it.limit + "件"
                    : item.countType == 3
                    ? it.limit + "笔"
                    : ""
                }可赠送${it.giveNum}次${this.taskTypeText}机会；`;
            });
          }
        } else if (type == 18) {
          str = `成功邀请好友入会${condition}次，赠送1次${this.taskTypeText}机会`;
        } else if (type == 5) {
          str = `成功浏览会场${item.viewTime || 1}秒，赠送${item.giveLimit || 1}次补卡机会`;
        }
        return str;
      };
    },
    // 获取任务次数
    getCount() {
      return (item) => {
        const {
          type,
          count,
          inviteLimit,
          condition2,
          activityType,
          orderCountType,
        } = item;
        let str = count;
        if (type == 12) {
          str = `活动期间最多完成${condition2}次`;
        } else if (type == 8) {
          str = `活动期间最多完成${inviteLimit}次`;
        } else if (type == 16) {
          str = `${
            activityType == 2 ? "活动期间" : "活动期间每日"
          }最多完成${condition2}次`;
        } else if (type == 17 && item.giveType == 0) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : "1"}次`;
        } else if (type == 17 && item.giveType != 0) {
          str =
            item.taskDoType == 0
              ? "活动期间不限次数"
              : `活动期间最多获得${item.condition2}次${this.taskTypeText}机会`;
        } else if (type == 18) {
          str = `活动期间最多完成${condition2}次`;
        }
        return str;
      };
    },
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
  },
  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds&&this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    handlerTaskList(taskList = []) {
      const goodsPromise = [];
      this.taskDataList = taskList.map((item) => {
        const obj = {
          type: item.taskType,
          taskTime: item.taskValidity,
          condition: null,
          condition2: null,
          count: null,
          endTime: null,
          startTime: null,
          skuIds: [],
          inviteLimit: null,
          jumpUrl: null,
          selectGoodsSkuList: [],
          activityType:
            item.taskType == 16 || item.taskType == 17 || item.taskType == 7
              ? item.activityType
              : 1,
          skuType: 0,
          orderType: 0,
          orderCountType: 1,
          itemTotalLimit: null,
          amtLimit: null,
          orderEndTime: null,
          orderStartTime: null,
          orderPaymentType: 1,
          mergeOrder: false,
        };
        // 指定时间
        if (item.taskValidity == 2) {
          obj.startTime = item.startTime;
          obj.endTime = item.endTime;
        }
        // 商品
        if (item.skuIds) {
          obj.skuIds = item.skuIds.split(",");
          let skuIdsLength = obj.skuIds.length;
          let skuIds = obj.skuIds.toString();
          goodsPromise.push(
            getTaobaoItemListSku({
              current: 1,
              size: skuIdsLength,
              skuIds: skuIds.split(","),
            })
          );
        }
        // 浏览会场-跳转链接
        if (item.taskType == 5) {
          obj.jumpUrl = item.jumpUrl;
          obj.viewTime = item.viewTime;
          obj.giveLimit = item.giveLimit;
        }
        // 查询关键词
        if (item.taskType == 23) {
          obj.searchKeyword = item.searchKeyword;
          obj.activityType = 1;
          obj.giveLimit = 1;
        }
        // 好友助力-邀请人数上限
        if (item.taskType == 8) {
          obj.inviteLimit = item.inviteLimit;
        }
        if (item.taskType == 17) {
          obj.orderCountType = item.orderCountType;
          obj.orderType = item.orderType;
          obj.skuType = item.skuType;
          obj.itemTotalLimit = item.itemTotalLimit;
          obj.amtLimit = item.amtLimit;
          obj.orderStartTime = item.orderStartTime;
          obj.orderEndTime = item.orderEndTime;
          obj.giveType = item.giveType;
          obj.countType = item.countType;
          (obj.taskDoType = item.taskDoType),
            (this.taskLevelList = item.stepList ? item.stepList : []);
          this.selectGoodsSkuList = item.itemList;
          obj.selectGoodsSkuList = item.itemList;
          obj.venderIds =
            item.venderIds
              ? item.venderIds.split(",").map((item) => +item)
              : [this.$store.getters.loginUserInfo.venderId];
          obj.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
            skuIds: item.skuIds ? item.skuIds.split(",") : [],
            venderId: this.$store.getters.loginUserInfo.venderId,
            itemList: [],
          }];
          obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
          obj.mergeOrder = item.mergeOrder || false;
        }
        if (item.taskType == 18) {
          obj.condition = item.inviteLimit;
          obj.condition2 = item.taskDoLimit;
        }
        // 任务门槛上限
        const taskTypeObj = this.taskTypeOptions.find(
          (option) => option.value == item.taskType
        );
        if (this.conditionValue.includes(item.taskType)) {
          if (item.taskType == 12) {
            obj.condition = item.giveLimit;
            obj.condition2 = item.taskDoLimit;
          } else if (item.taskType == 4) {
            obj.condition = item.addCartLimit;
            obj.count = taskTypeObj.taskCount;
          } else if (item.taskType == 16) {
            obj.condition = item.giveLimit;
            obj.condition2 = item.taskDoLimit;
            obj.activityType = item.activityType;
          } else if (item.taskType == 17) {
            obj.activityType = 2;
            obj.condition = item.giveLimit;
            obj.condition2 = item.taskDoLimit;
            obj.count = taskTypeObj.taskCount;
          } else {
            obj.condition = item.giveLimit;
            obj.count = taskTypeObj.taskCount;
          }
        } else {
          obj.condition = taskTypeObj.taskCondition;
          obj.count = taskTypeObj.taskCount;
        }
        if (item.taskType == 7) {
          obj.giveLimit = item.giveLimit;
        }
        return obj;
      });
      Promise.all(goodsPromise).then((res) => {
        this.taskDataList
          .filter((item) => item.skuIds && item.skuIds.length)
          .forEach((item, index) => {
            item.selectGoodsSkuList = res[index].data.records;
          });
        this.changeTaskDataList();
      });
    },
    // 商品组件回调
    selectGoodsChange(val) {
      if (val) {
        let isGoods = false;
        val.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
         }
        let valArr = [];
        this.selectGoodsSkuList = val;
        this.taskForm.selectGoodsSkuList = val;
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        console.log(valArr);
        this.taskForm.skuIds = valArr;
      }
      this.goodsState = false;
    },
    addTaskLevel() {
      let postData = {
        taskIndex: 1,
        limit: "",
        giveNum: "",
      };
      postData.taskIndex = this.taskLevelList.length + 1;
      this.taskLevelList.push(postData);
    },
    delTaskLevel(index) {
      this.taskLevelList.splice(index, 1);
    },
    NumChange(e, key, valueIndex) {
      let res = e;
      this.taskLevelList.forEach((item, index) => {
        if (valueIndex > index) {
          if (parseFloat(res) <= parseFloat(item[key])) {
            res = "";
          }
        }
      });
      return res;
    },
    countTypeChange() {
      this.taskLevelList.forEach((item) => {
        item.limit = "";
      });
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = "999999.99"; // 设置为最大值
      }
      this.taskForm.amtLimit = newValue.replace(/^0+(\d)/, "$1");
    },
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = "999"; // 设置为最大值
      }

      this.taskForm.itemTotalLimit = newValue;
    },

    // 控制大于0 - 正数可包含小数点
    inputValidateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = "999999.99"; // 设置为最大值
      }
      return newValue.replace(/^0+(\d)/, "$1");
    },
    inputValidateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = "999"; // 设置为最大值
      }

      return newValue;
    },
    // 商品弹窗
    showGoods(limit = 100) {
      this.goodsLimit = limit;
      this.goodsState = true;
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    giveTypeChange(e) {
      if (e == 1) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
        ];
      }
      if (e == 2) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
          {
            taskIndex: 2,
            limit: "",
            giveNum: "",
          },
        ];
      }
    },
    // 清空任务时间
    clearTaskTime() {
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 新增任务
    addTask() {
      console.log("新增任务");
      this.isTaskEdit = false;
      this.isLook = false;
      this.taskIsLook = false;
      this.taskForm = {
        giveType: 0,
        countType: 1,
        taskDoType: 0,
        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        selectGoodsSkuList: [],
        inviteLimit: null,
        jumpUrl: null,
        activityType: 2,
        skuType: 0,
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        orderPaymentType: 1,
        mergeOrder: false,
      };
      this.selectGoodsSkuList = [];
      this.taskTypeChange(1);
    },
    // 任务类型change
    taskTypeChange(e) {
      const obj = this.taskTypeOptions.find((item) => item.value == e);
      if (!this.conditionValue.includes(e)) {
        this.taskForm.condition = obj.taskCondition;
      } else {
        this.taskForm.condition = null;
        this.taskForm.condition2 = null;
        this.taskForm.activityType = 2;
      }
      // 任务次数
      if (e == 12) {
        this.taskForm.count = null;
      } else {
        this.taskForm.count = obj.taskCount;
      }
      // 购买商品 - tip：不能加入goodsTypeList 因为保存时不做限制
      if (this.taskForm.type == 17) {
        this.initData();
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
        this.taskForm.giveType = 0;
      }
      // 商品
      if (this.goodsTypeList.includes(e)) {
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
      }
      this.taskForm.taskTime = 1;
    },
    changeTaskDataList() {
      const taskList = this.taskDataList.map((item) => {
        const obj = {
          activityType:
            item.type == 8 ||
            item.type == 12 ||
            item.type == 7 ||
            (item.type == 16 && item.activityType == 2)
              ? 2
              : 1,
          taskType: item.type,
          taskValidity: item.taskTime,
        };
        // 指定时间
        if (item.taskTime == 2) {
          obj.startTime = item.startTime;
          obj.endTime = item.endTime;
        }
        // 商品
        if (item.skuIds.length) {
          obj.skuIds = item.skuIds.join(",");
        }
        if (item.type == 18) {
          obj.activityType = 2;
          obj.inviteLimit = item.condition;
          obj.taskDoLimit = item.condition2;
        }
        // 浏览会场-跳转链接
        if (item.type == 5) {
          obj.jumpUrl = item.jumpUrl;
          obj.viewTime = item.viewTime;
          obj.giveLimit = item.giveLimit;
        }
        // 查询关键词
        if (item.type == 23) {
          obj.searchKeyword = item.searchKeyword;
          obj.activityType = 1;
          obj.giveLimit = 1;
        }
        // 好友助力-邀请人数上限
        if (item.type == 8) {
          obj.inviteLimit = item.inviteLimit;
        }
        if (item.type == 17) {
          obj.activityType = 2;
          obj.orderCountType = item.orderCountType;
          obj.orderType = item.orderType;
          obj.skuType = item.skuType;
          obj.itemTotalLimit = item.itemTotalLimit;
          obj.amtLimit = item.amtLimit;
          obj.orderStartTime = item.orderStartTime;
          obj.orderEndTime = item.orderEndTime;

          obj.giveType = item.giveType;
          obj.countType = item.countType;
          (obj.taskDoType = item.taskDoType), (obj.stepList = item.stepList);
          obj.venderIds = item.venderIds.join(",");
          obj.sellerSkuList = item.sellerSkuList.map((item)=>{
            return {
              skuIds: item.skuIds,
              venderId: item.venderId,
            }
          });
          obj.orderPaymentType = item.orderPaymentType;
          obj.mergeOrder = item.mergeOrder;
        }
        // 任务门槛上限
        if (this.conditionValue.includes(item.type)) {
          if (item.type == 12 || item.type == 16) {
            obj.giveLimit = item.condition;
            obj.taskDoLimit = item.condition2;
          } else if (item.type == 4) {
            // 加购商品
            obj.addCartLimit = item.condition;
          } else if (item.type == 17) {
            obj.giveLimit = 1;
            if (
              item.orderCountType == 0 ||
              ((this.taskForm.giveType == 1 || this.taskForm.giveType == 2) &&
                this.taskForm.taskDoType == 1)
            ) {
              obj.taskDoLimit = item.condition2;
            } else {
              obj.taskDoLimit = 1;
            }
          } else {
            obj.giveLimit = item.condition;
          }
        }
        if (item.type == 7) {
          obj.giveLimit = item.giveLimit;
        }
        return obj;
      });
      console.log("taskList", taskList);
      this.$emit("update:taskList", taskList);
    },
    // 修改
    editTask(row, isLook) {
      const copyRow = JSON.parse(JSON.stringify(row));
      this.taskRow = row;
      this.isTaskEdit = true;
      this.taskForm = copyRow;
      // 商品回显
      this.selectGoodsSkuList = copyRow.selectGoodsSkuList;
      // this.$emit("input", true);
      this.taskDialog = true;
      this.taskIsLook = isLook;
      // 购买商品新增下单店铺回显处理
      if (this.taskForm.type == 17) {
        this.initData();
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
            const reqList = this.taskForm.sellerSkuList.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
              });
            });
          }
        }
      }
    },
    // 删除
    deleteTask(row) {
      const index = this.taskDataList.findIndex(
        (item) => item.type == row.type
      );
      this.taskDataList.splice(index, 1);
      this.changeTaskDataList();
    },
    // 上移
    upTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index - 1,
        1,
        this.taskDataList[index]
      )[0];
      this.changeTaskDataList();
    },
    // 下移
    downTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index + 1,
        1,
        this.taskDataList[index]
      )[0];
      this.changeTaskDataList();
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 确认添加任务
    sureTask() {
      console.log("this.taskForm", this.taskForm);
      // 任务有效期
      if (this.taskForm.taskTime == 2) {
        if (!this.taskForm.startTime || !this.taskForm.startTime) {
          return this.$message.warning("请填写任务有效期");
        }
        if (this.taskForm.startTime && this.taskForm.endTime) {
          const startTime = new Date(
            this.taskForm.startTime + " 23:59:59"
          ).getTime();
          const endTime = new Date(
            this.taskForm.endTime + " 00:00:00"
          ).getTime();
          const activityStartTime = new Date(this.activityStartTime).getTime();
          const activityEndTime = new Date(this.activityEndTime).getTime();
          if (startTime > endTime) {
            return this.$message.warning("结束时间不能小于开始时间");
          }
          if (activityStartTime > startTime || endTime > activityEndTime) {
            return this.$message.warning(
              "任务有效期超出了活动时间范围，请重新选择"
            );
          }
        }
      }
      // 邀请人数上限
      if (this.taskForm.type == 8) {
        if (!this.taskForm.inviteLimit) {
          return this.$message.warning("请填写邀请人数上限");
        }
      }
      // 跳转链接
      if (this.taskForm.type == 5) {
        if (!this.taskForm.jumpUrl) {
          return this.$message.warning("请填写跳转链接");
        }
        if (!this.taskForm.viewTime) {
          return this.$message.warning("请输入浏览时间");
        }
        if (!this.taskForm.giveLimit) {
          return this.$message.warning("请输入奖励次数");
        }
      }
      // 搜索关键词
      if (this.taskForm.type == 23) {
        if (!this.taskForm.searchKeyword) {
          return this.$message.warning("请输入搜索关键词");
        }
      }
      // 购买商品类型
      if (this.taskForm.type == 17) {
        // 下单时间-------------
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime) {
          return this.$message.warning("请填写下单时间");
        }
        if (this.taskForm.orderStartTime && this.taskForm.orderEndTime) {
          const startTime = new Date(
            this.taskForm.orderStartTime + " 00:00:00"
          ).getTime();
          const endTime = new Date(
            this.taskForm.orderEndTime + " 00:00:00"
          ).getTime();
          if (startTime > endTime) {
            return this.$message.warning("下单结束时间不能小于下单开始时间");
          }
        }
        // 订单金额-------------
        if (!this.taskForm.amtLimit && this.taskForm.giveType == 0) {
          return this.$message.warning("请填写订单金额");
        }
        // 指定商品-------------
        // if (
        //   this.taskForm.skuType == 1 &&
        //   (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)
        // ) {
        //   return this.$message.warning("请选择指定商品");
        // }
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            return this.$message.warning(`请选择${shop.shopTitle}的指定商品`);
          }
        }
        if (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) {
          let isLimit = false;
          let isLimitZero = false;
          this.taskLevelList.forEach((item) => {
            if (!item.limit || !item.giveNum) {
              isLimit = true;
            }
            if (item.limit == 0 && item.limit != "") {
              isLimitZero = true;
            }
          });
          if (isLimitZero) {
            return this.$message.warning("任务条件值需大于0");
          }
          if (isLimit) {
            return this.$message.warning("请填写任务条件");
          }
          if (!this.taskForm.condition2 && this.taskForm.taskDoType == 1) {
            return this.$message.warning("请填写任务次数");
          }
        }
        // 单笔订单-任务次数
        if (
          this.taskForm.orderCountType == 0 &&
          !this.taskForm.condition2 &&
          this.taskForm.giveType == 0
        ) {
          return this.$message.warning("请填写任务次数");
        }

        if (this.taskForm.giveType == 2) {
          let limitArr = [];
          let giveNumArr = [];
          this.taskLevelList.forEach((item) => {
            limitArr.push(item.limit);
            giveNumArr.push(item.giveNum);
          });
          if (!this.isMonotonicIncreasing(limitArr)) {
            return this.$message.warning("高级阶梯笔数需大于低级阶梯笔数");
          }
          if (!this.isMonotonicIncreasing(giveNumArr)) {
            return this.$message.warning(
              `高级阶梯${this.taskTypeText}机会需大于低级阶梯${this.taskTypeText}机会`
            );
          }
        }
        if (
          (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) &&
          this.taskForm.taskDoType == 1
        ) {
          let number = 0;
          this.taskLevelList.forEach((item) => {
            number = Number(item.giveNum) + number;
          });
          if (Number(this.taskForm.condition2) < number) {
            return this.$message.warning(
              `任务次数不可低于任务条件可得${this.taskTypeText}机会`
            );
          }
        }
      }

      // 任务条件
      if (
        this.conditionValue.includes(this.taskForm.type) &&
        this.taskForm.type != 17
      ) {
        if (!this.taskForm.condition) {
          return this.$message.warning("请填写任务条件");
        }
      }
      // 商品
      if (this.goodsTypeList.includes(this.taskForm.type)) {
        if (this.taskForm.skuIds.length == 0) {
          const obj = this.taskTypeOptions.find(
            (item) => item.value == this.taskForm.type
          );
          return this.$message.warning(`请填写${obj.label}`);
        } else if (
          this.goodsLimitList.includes(this.taskForm.type) &&
          this.taskForm.condition > this.taskForm.skuIds.length
        ) {
          return this.$message.warning(
            `任务商品件数不得大于已选商品件数，请重新选择~`
          );
        }
      }
      // 任务次数
      if (
        this.taskForm.type == 18 ||
        this.taskForm.type == 12 ||
        this.taskForm.type == 16 ||
        (this.taskForm.type == 17 &&
          this.taskForm.orderCountType == 0 &&
          this.taskForm.giveType == 0)
      ) {
        if (!this.taskForm.condition2) {
          return this.$message.warning("请填写任务次数");
        }
      }
      // 抽奖次机会
      if (this.taskForm.type == 7) {
        if (!this.taskForm.giveLimit) {
          return this.$message.warning(`请填写${this.taskTypeText}次数`);
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm));
      obj.stepList = JSON.parse(JSON.stringify(this.taskLevelList));
      console.log("obj", obj);
      // return;
      const index = this.taskDataList.findIndex(
        (item) => item.type == this.taskForm.type
      );
      if (index != -1 && !this.isTaskEdit) {
        return this.$message.warning("列表已存在该类型任务，请勿重复添加~");
      } else {
        // 修改
        if (this.isTaskEdit) {
          const index = this.taskDataList.findIndex(
            (item) => item.type == this.taskRow.type
          );
          this.taskDataList.splice(index, 1, obj);
        } else {
          this.taskDataList.push(obj);
        }
        this.changeTaskDataList();
      }
      this.taskClose();
    },
    taskClose() {
      this.taskDialog = false;
      this.$emit("input", false);
      this.$emit("taskClose");
    },
  },
};
</script>

<style scoped lang="scss">
.task-wrap {
  display: flex;
  align-items: center;
  &-radio {
    margin-right: 10px;
  }
}
.rule_box {
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
</style>
